export const DENSITY = {
  BLOCK: 'block',
  COMPACT: 'compact',
  COMFORTABLE: 'comfortable',
} as const;

export type Density = (typeof DENSITY)[keyof typeof DENSITY];
